export function extractMediumAndSource(adKey: string) {
  let medium;
  let source;

  try {
    const parsedAdKey = JSON.parse(adKey);
    const adKeyPlatform = JSON.parse(parsedAdKey.platform);
    medium = adKeyPlatform.medium;
    source = adKeyPlatform.source;
  } catch {
    // Do nothing
  }

  return { medium, source };
}
